import { isEmpty } from 'lodash';
import { CustomValidateResolveType } from 'tdesign-react';

import { RichMediaValue } from '@/interface/media';

const validateImage: (
  value: RichMediaValue,
  name: string,
  message?: string,
  isCloseGetColor?: boolean
) => CustomValidateResolveType = (value, name, message, isCloseGetColor) => {
  const tip = message || `请上传${name}`;
  const sampleTip = `${name}取色失败，请重新上传`;

  if (isErrorRichMedia(value)) {
    return { result: false, message: tip, type: 'error' };
  }
  if (isEmpty(value?.sample) && !isCloseGetColor) {
    return { result: false, message: sampleTip, type: 'error' };
  }
  return true;
};

const isErrorRichMedia = (val?: RichMediaValue): boolean => !val || isEmpty(val.url?.url);

export { isErrorRichMedia, validateImage };
